import React, { useContext } from "react";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import swipeSVG from "../assets/swipe.svg";
import { PreviewContext } from "../helpers";

interface ScrollTableProps {
  className?: string;
}

const ScrollTable: React.FunctionComponent<ScrollTableProps> = ({
  className,
  children,
}) => {
  const previewMode = useContext(PreviewContext);

  return (
    <div className="ScrollTable">
      <table className={className}>
        {!previewMode && (
          <caption className="ScrollTable__MobileHelp" aria-hidden="true">
            <img
              aria-hidden="true"
              src={swipeSVG}
              role="presentation"
              alt=" "
            />
            <span>
              <FormattedHTMLMessage id="scroll_table.swipe_to_view_more" />
            </span>
          </caption>
        )}
        {children}
      </table>
    </div>
  );
};

export default ScrollTable;
